// frontend/src/services/contractService.js
// frontend/src/services/contractService.js = Phase 8 Contracts API client for the UPS-admin permission plane.
// Centralizes all HTTP calls to /ups-admin/contracts endpoints (list/create contracts, toggle contract status, fetch site permissions, toggle contract-site status) and returns backend-shaped payloads for Redux thunks.
// Phase 8: Contracts API client (UPS-admin permission plane)

import axios from 'axios';

const BASE = '/ups-admin/contracts';

// GET /ups-admin/contracts
// Purpose: Fetch all contracts for the current company (UPS-admin scope).
export async function fetchContractsApi() {
  const { data } = await axios.get(BASE);
  return data; // { contracts: [...] }
}

// GET /ups-admin/contracts/:id/sites
// Purpose: Fetch all company sites with contract-site permission status for checklist UI.
export async function fetchContractSitesApi(contractId) {
  const { data } = await axios.get(`${BASE}/${contractId}/sites`);
  return data; // { sites: [...] } or [...]
}


// POST /ups-admin/contracts
// Purpose: Create (or idempotently ensure) a contract between company and agency.
export async function createContractApi({ agencyId }) {
  const { data } = await axios.post(BASE, { agencyId });
  return data; // { contract: {...} }
}

// PATCH /ups-admin/contracts/:id
// Purpose: Enable or disable a contract at the company ↔ agency level.
export async function setContractStatusApi(contractId, status) {
  const { data } = await axios.patch(`${BASE}/${contractId}`, { status }); // 'active' | 'disabled'
  return data; // { contract: {...} }
}

// GET /ups-admin/contracts/:id/sites/:siteId/impact
// Purpose: Preview operational impact (open assignment counts) before re-enabling a disabled contract-site.
export async function fetchContractSiteImpactApi(contractId, siteId) {
  const { data } = await axios.get(`${BASE}/${contractId}/sites/${siteId}/impact`);

  // Normalize so callers always receive: { total, requested, confirmed, active }
  // Backend currently returns: { ..., open: { total, requested, confirmed, active } }
  // This makes UI code stable even if backend shape changes later.
  return data?.open ?? data ?? {};
}


// PATCH /ups-admin/contracts/:id/sites/:siteId
// Purpose: Enable or disable a specific site under a contract (UPS-admin permission toggle).
export async function setContractSiteStatusApi(contractId, siteId, status) {
  const { data } = await axios.patch(`${BASE}/${contractId}/sites/${siteId}`, { status });
  return data; // { contract_site: {...} }
}
